<template>
  <div>
    <h1>Lista de CNPJ</h1>
    <b-card>
      <div class="d-flex mb-2">
        <div class="mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            size="sm"
            variant="exitos"
            :to="{ name: 'cnpjs_create' }"
            v-if="$can('cnpj:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table
        striped
        hover
        :items="cnpjs"
        :fields="fields"
        :busy="isBusy"
        @sort-changed="sortingChanged"
        show-empty
        sort-icon-left
      >
        <template #cell(estados)="{ item }">
          <div v-for="(estado, key) in item.estados" :key="key">
            {{ estado.sigla }} - {{ estado.nome }}
          </div>
        </template>

        <template #cell(municipios)="{ item }">
          <div v-for="(municipio, key) in item.municipios" :key="key">
            {{ municipio.estado_sigla }} - {{ municipio.nome }}
          </div>
        </template>

        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('cnpj:edit')"
            :view_delete="$can('cnpj:delete')"
            edit_to="cnpjs_edit"
            @delete="deleteItem"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </b-card>

    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";
import mixins from "@/components/Table/mixins";

export default {
  components: { Actions },
  mixins: [mixins],

  computed: {
    ...mapState("cnpj", ["cnpjs", "pagination"]),
    fields() {
      return [
        {
          key: "cnpj",
          label: "CNPJ",
          class: "col-2",
          formatter: (value, head, object) => {
            return this.$options.filters.cnpj(value);
          },
        },
        { key: "nome", label: "nome", class: "col-3", sortable: true },
        { key: "estados", label: "Estados", class: "col-3" },
        {
          key: "municipios",
          label: "Municipios",
          class: "col-4",
        },

        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("cnpj", ["ActionGetAll", "ActionDelete"]),
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    if (this.$route.query.q != "") {
      this.termo_pesquisa = this.$route.query.q;
    }
    this.loadData();
  },
};
</script>

<style></style>
